import React from 'react';
import { Container, Navbar } from 'react-bootstrap';

const TopNavBar = () => (
    <header id="header" className="header-simple">
        <Navbar bg="white" expanded="true" className="navbar" aria-label="navbar">
            <Container>
                <Navbar.Brand className="me-auto" href="/">DaBilet</Navbar.Brand>
            </Container>
        </Navbar>
    </header>
);

export default TopNavBar;
